import { render, staticRenderFns } from "./modal-language-selector.vue?vue&type=template&id=2995d3cc&scoped=true"
import script from "./modal-language-selector.vue?vue&type=script&lang=ts"
export * from "./modal-language-selector.vue?vue&type=script&lang=ts"
import style0 from "./modal-language-selector.vue?vue&type=style&index=0&id=2995d3cc&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995d3cc",
  null
  
)

export default component.exports